import { AbstractSlide } from '@/services/proposal/Slide'
import { SlideType } from '@ankor-io/common/proposal/SlideType'

export class YachtProposalSlide extends AbstractSlide {
  getType(): SlideType {
    return SlideType.YACHT
  }
}
